






























import { Component, Vue, PropSync, Prop } from "vue-property-decorator"
import { ORDER_BY_DIRECTION_LIST } from '@/constants/filter'
import _ from 'lodash'

@Component({
})
export default class BusinessListFilterChip extends Vue {
  @PropSync('options') optionsSynced!: BusinessListFilterOptions
  @Prop({ default: false }) readonly disabled!: boolean;
  @Prop({ default: false }) readonly loading!: boolean;

  directionList = ORDER_BY_DIRECTION_LIST

  optionsLocal!: BusinessListFilterOptions

  orderByList = [
    {
      text: 'Name',
      value: 'name',
    },
    {
      text: 'Object ID',
      value: 'object_id',
    },
    {
      text: 'Created At',
      value: 'created_at',
    },
    {
      text: 'Update At',
      value: 'updated_at',
    },
  ]

  isMounted = false

  mounted() {
    this.optionsLocal = _.cloneDeep(this.optionsSynced)
    this.isMounted = true
  }

  orderByName (value) {
    const name = this.orderByList.find(item => item.value === value)
    if (name) {
      return name.text
    }
    return ''
  }

  directionName (value) {
    const name = this.directionList.find(item => item.value === value)
    if (name) {
      return name.text
    }
    return ''
  }

  directionIcon () {
    if (this.optionsSynced.orderByDirection == 'asc') {
      return 'mdi-sort-ascending'
    } else {
      return 'mdi-sort-descending'
    }
  }

  closeQuery () {
    this.optionsSynced.query = null
  }

  closeSort () {
    this.optionsSynced.orderBy = null
  }

  switchOrderByDirection() {
    if (this.optionsSynced.orderByDirection == 'asc') {
      this.optionsSynced.orderByDirection = 'desc'
    } else {
      this.optionsSynced.orderByDirection = 'asc'
    }
  }

}
